import styled from 'styled-components';

export const NavWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  border-top: 1px solid #e0e0e0;
  display: flex;
  justify-content: space-around;
  padding: 8px 0;
  z-index: 100;
  max-width: 1024px;
  margin: 0 auto;
`;

export const NavItem = styled.button`
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  color: ${props => props.color};
  font-size: 10px;
  font-weight: 500;
  padding: 4px 8px;

  svg {
    font-size: 20px;
  }
`;
